import { Switch } from "@shared/components/DataEntry";

import { useActiveStoreSwitch } from "./controller";
import { ActiveStoreSwitchProps } from "./types";

export function ActiveStoreSwitch(props: ActiveStoreSwitchProps) {
  const { isActive, isPending, toggle } = useActiveStoreSwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
